export enum AddressTabIndex {
  Manual = 1,
  Search = 0,
}
